















import Vue from 'vue'
import { ProductCardFunction } from '@/search/types'

const DISABLED_COLOR = '#FAFAFA'

export default Vue.extend({
  props: {
    functions: {
      type: Array as () => ProductCardFunction[],
      default: () => []
    }
  },
  computed: {
    DISABLED_COLOR(): string {
      return DISABLED_COLOR
    }
  },
  methods: {
    getDisplayName(name: string): string {
      return name.split('_').join('\n')
    }
  }
})
